import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
import LocationWebAPIUtils from 'utils/LocationWebAPIUtils';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  getLocations(params) {
    LocationWebAPIUtils.getLocations(params);
  },
  getLocation(id) {
    LocationWebAPIUtils.getLocation(id);
  },
  findLocations(params) {
    LocationWebAPIUtils.findLocations(params);
  },
  createLocation(location) {
    LocationWebAPIUtils.createLocation(location);
  },
  updateLocation(location) {
    LocationWebAPIUtils.updateLocation(location);
  },
  addLocationAlias(id, alias) {
    LocationWebAPIUtils.addLocationAlias(id, alias);
  },
  deleteLocationAlias(id, alias) {
    LocationWebAPIUtils.deleteLocationAlias(id, alias);
  },
  createLocationPair(params) {
    LocationWebAPIUtils.createLocationPair(params);
  },
  getLocationPairs(params) {
    LocationWebAPIUtils.getLocationPairs(params);
  },
  updateLocationPair(id, updates) {
    LocationWebAPIUtils.updateLocationPair(id, updates);
  },
  removeLocationPair(id) {
    LocationWebAPIUtils.removeLocationPair(id);
  },
  removeLocation(id) {
    LocationWebAPIUtils.removeLocation(id);
  },
  clearLocation() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.CLEAR_LOCATION,
    });
  },
};
